import api, { apiRequest } from "../api/apiClient";
import { User } from "../types/slice.types";
import { LoginCredentials, SignupCredentials } from "../types/userData.types";

const ROUTE_PREFIX = "/auth";

const registerCall = async (header: SignupCredentials) => {
  const { data, error } = await apiRequest("post", "/auth/register", header);
  if (data && data?.token) {
    localStorage.setItem("token", data.token);
  }
  return { data, error };
};

const loginCall = async (header: LoginCredentials) => {
  const { data, error } = await apiRequest(
    "post",
    `${ROUTE_PREFIX}/login`,
    header
  );

  if (data && data?.token) {
    localStorage.setItem("token", data.token);
  }
  return { data, error };
};

const logoutCall = async () => {
  await api.post(`${ROUTE_PREFIX}/logout`);
  localStorage.removeItem("token");
};

const editProfileCall = async (payload: Partial<User>) => {
  const { data, error } = await apiRequest(
    "put",
    `${ROUTE_PREFIX}/profile`,
    payload
  );

  return { data, error };
};

export { editProfileCall, loginCall, logoutCall, registerCall };
